export function compareIrisVersions(v1: string, v2: string, excludePatch = false ): number | undefined {
  if (!v1 || !v2) {
    return undefined;
  }
  if (excludePatch) {
    v1 = v1.split('.').slice(0,2).join('.');
    v2 = v2.split('.').slice(0,2).join('.');
  }
  return v1.localeCompare(v2);
}
